import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackCheckoutCreditPackQuantityChanged.meta';

export type UseTrackCheckoutCreditPackQuantityChangedParams = CreditAnalyticsParams & {
  pack_quantity: number;
};

export const useTrackCheckoutCreditPackQuantityChanged = () => {
  const { track } = useAnalyticsUtilities();

  const trackCheckoutCreditPackQuantityChanged = useCallback(
    (params: UseTrackCheckoutCreditPackQuantityChangedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCheckoutCreditPackQuantityChanged };
};
